import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import sampleimg from "../../assets/images/profile.png";
import deleteicon from "../../assets/images/svg/delete-icon.svg";
import addicon from "../../assets/images/svg/tabler_plus.svg";
import { $crud } from "../../utils/CrudFactory";
import { toLocalTime } from "../../helper/functions";

const columns = [
  {
    label: "Category Name",
    key: "name",
  },
  {
    label: "Created Date",
    key: "createdAt",
    renderCell: (row) => toLocalTime(row.createdAt),
  },
  {
    label: "Assigned Orders",
    key: "assignedOrders",
  },
  {
    label: "Status",
    key: "status",
  },
  {
    label: "Image",
    key: "image",
  },
];

const CategoryItemTable = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [changeImage, setchangeImage] = useState(false);
  async function handleChangeImage(e) {
    const formdata = new FormData();
    formdata.append("image", e.target.files[0]);
    try {
      const res = await $crud.put(
        `admin/accepted-category/${state._id}/image`,
        formdata
      );
      navigate("/others/accepted-categories");
    } catch (e) {
      return;
    }
  }
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead sx={{ backgroundColor: "rgba(103, 60, 142, 1)" }}>
          <TableRow>
            <TableCell
              align="center"
              sx={{ fontWeight: "bold", width: "50%", color: "#ffffff" }}
            >
              Category Details
            </TableCell>
            <TableCell
              align="center"
              sx={{ fontWeight: "bold", color: "#ffffff" }}
            >
              Item Details
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{ backgroundColor: "#ffffff" }}>
          {columns.map((row, index) => (
            <TableRow
              sx={{
                border: "1px solid rgba(103, 60, 142, 1)",
              }}
              key={index}
            >
              <TableCell
                sx={{
                  color: "black",
                  fontWeight: "bold",
                  border: "1px solid rgba(103, 60, 142, 1)",
                  borderRight: "1px solid rgba(103, 60, 142, 1)",
                }}
                align="start"
              >
                {row.label}
              </TableCell>
              <TableCell
                sx={{
                  color: "black",
                  border: "1px solid rgba(103, 60, 142, 1)",
                }}
                align="start"
              >
                {row.key === "image" ? (
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                  >
                    {changeImage ? (
                      <>
                        <label
                          htmlFor="change-image"
                          style={{
                            width: "110px",
                            height: "110px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid rgba(103, 60, 142, 1)",
                          }}
                        >
                          <img
                            src={addicon}
                            width={"25px"}
                            height={"25px"}
                            alt=""
                          />
                        </label>
                        <input
                          type="file"
                          onChange={handleChangeImage}
                          id="change-image"
                          style={{ display: "none" }}
                        />
                      </>
                    ) : (
                      <>
                        <img
                          src={state.image}
                          style={{ width: "110px", height: "110px" }}
                          alt=""
                        />
                        <IconButton
                          onClick={() => {
                            setchangeImage(true);
                          }}
                          size="small"
                        >
                          <img src={deleteicon} alt="" />
                        </IconButton>
                      </>
                    )}
                  </Box>
                ) : row.renderCell ? (
                  row.renderCell(state)
                ) : (
                  state[row.key]
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CategoryItemTable;
